import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import creationSlice from "./slice/creationSlice";

const store = configureStore({
  reducer: {
    userReducer: userSlice,
    creationReducer: creationSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
